import { get } from "lodash";

/* function to change the colors to hexadecimal that are in variables.css
add another case if a color is added in the variable.css file
*/
export function getColor(id: string = null) {
  const colorList = {
    "navy-500": "#002558",
    "navy-501": "#004276",
    "navy-502": "#005f96",
    "red-500": "#f44336",
    "red-800": "#c62828",
    "red-900": "#b71c1c",
    "pink-500": "#e91e63",
    "pink-800": "#ad1457",
    "pink-900": "#880e4f",
    "purple-500": "#9c27b0",
    "purple-800": "#6a1b9a",
    "purple-900": "#4a148c",
    "deeppurple-500": "#673ab7",
    "deeppurple-800": "#4527a0",
    "deeppurple-900": "#311b92",
    "indigo-500": "#3f51b5",
    "indigo-800": "#283593",
    "indigo-900": "#1a237e",
    "blue-500": "#2196f3",
    "blue-800": "#1565c0",
    "blue-900": "#0d47a1",
    "lightblue-500": "#03a9f4",
    "lightblue-800": "#0277bd",
    "lightblue-900": "#01579b",
    "cyan-500": "#00bcd4",
    "cyan-800": "#00838f",
    "cyan-900": "#006064",
    "teal-500": "#009688",
    "teal-800": "#00695c",
    "teal-900": "#004d40",
    "green-500": "#4caf50",
    "green-800": "#2e7d32",
    "green-900": "#1b5e20",
    "green-ean": "#3BAC53",
    "lightgreen-500": "#8bc34a",
    "lightgreen-800": "#558b2f",
    "lightgreen-900": "#33691e",
    "lime-500": "#cddc39",
    "lime-800": "#9e9d24",
    "lime-900": "#827717",
    "yellow-500": "#ffeb3b",
    "yellow-800": "#f9a825",
    "yellow-900": "#f57f17",
    "amber-500": "#ffc107",
    "amber-800": "#ff8f00",
    "amber-900": "#ff6f00",
    "orange-500": "#ff9800",
    "orange-800": "#ef6c00",
    "orange-900": "#e65100",
    "deeporange-500": "#ff5722",
    "deeporange-800": "#d84315",
    "deeporange-900": "#bf360c",
    "brown-500": "#795548",
    "brown-800": "#4e342e",
    "brown-900": "#3e2723",
    "grey-200": "#EEEEEE",
    "grey-500": "#9e9e9e",
    "grey-800": "#424242",
    "grey-900": "#212121",
    "bluegrey-500": "#607d8b",
    "bluegrey-800": "#37474f",
    "bluegrey-900": "#263238",
    clear: "#fff",
    dark: "#000",
    navy: "#2C5889",
    pale_blue: "#E9EFF8",
    orange: "#FF5B00",
    solid_blue: "#2E405A",
    "walk-1": "#1f9cd3",
    "navy-503": "#0091CE",
    "navy-504": "#005D7D",
    "custom-220": "#FABB09",
    "custom-230": "#0E204E",
    "custom-240": "#0372b9",
    "custom-250": "#231F20",
    "custom-251": "#ED1C24",
    "custom-252": "#F4EC43",
    "custom-253": "#E72991",
    "custom-254": "#F09139",
    "custom-255": "#FFD106",
    "custom-256": "#DD5061",
    "custom-257": "#eb1d29",
    "custom-270": "#273d58",
    "custom-271": "#3e5a72",
    "custom-272": "#FF6E1F",
    "custom-273": "#ff6a14",
    "custom-274": "#002BD2",
    "custom-275": "#DC8028",
    "custom-276": "#8b8884",
    "custom-277": "#b91f31",
    "custom-278": "#661d32",
    "custom-279": "#00D500",
    "custom-280": "#D28028",
    "custom-281": "#8D1D80",
    "custom-282": "#006C33",
    "custom-283": "#E35C2B",
    "custom-284": "#418FDE",
    "custom-285": "#39B54A",
    "custom-286": "#FF5800",
    "custom-287": "#999999",
    "custom-288": "#3366CA",
    "custom-289": "#03B0D8",
    "custom-290": "#FFAC00",
    "custom-291": "#180C3B",
    "custom-292": "#29FC2E",
    "custom-293": "#00af69",
    "custom-294": "#009962",
    "custom-295": "#980098",
    "custom-296": "#80FFFF",
    "custom-297": "#3B0076",
    "custom-298": "#01FBDA",
    "custom-299": "#0F138F",
    "custom-300": "#01FBDA",
    "custom-301": "#1f2446",
    "custom-302": "#293f95",
    "custom-303": "#1f65bb",
    "custom-304": "#68c7ff",
    "custom-305": "#fff7c7",
    "custom-306": "#ff9e1b",
    "custom-307": "#f4633a",
    "custom-308": "#235ba8",
    "custom-309": "#1c1f2a",
    "custom-310": "#4d3300",
    "custom-311": "#ffbc00",
    "custom-312": "#ff7800",
    "custom-313": "#698b00",
    "custom-314": "#b2e1ce",
    "custom-315": "#dfe2d9",
    "custom-316": "#E2000F",
    "custom-317": "#FFF1C4",
    "custom-318": "#F7AB59",
    "custom-319": "#EE7326",
    "custom-320": "#00496B",
    "custom-321": "#006D96",
    "custom-322": "#0067b1",
    "custom-323": "#3366CC",
    "custom-324": "#072D65",
    "custom-325": "#6791FD",
    "custom-330": "#c12a1a",
    "custom-331": "#c3360e",
    "custom-332": "#4b72b1",
    "custom-333": "#f4d600",
    "custom-334": "#191c17",

    "custom-335": "#FDBB33",
    "custom-336": "#FC8001",
    "custom-337": "#1CFFBF",
    "custom-338": "#1090F7",
  };

  if (id) {
    return get(colorList, id, "#fff");
  }

  const colorAll = [];
  Object.keys(colorList).map((key) => {
    colorAll.push({ name: key, value: colorList[key] });
  });
  return colorAll;
}



// WEBPACK FOOTER //
// ./src/pipes/color/color.helper.ts